<template>
    <div>
        <div v-if="isEditing">
            <b-form-input
                v-if="isType(['entityModalSelect','treeSelect'])"
                type="text"
                plaintext
                placeholder="请选择"
                @click="entityModalSelectClick($event,metadata)"
                v-model="myValue"
                class="form-control"
                @input="updateValue()"
                :disabled="metadata.disabled"
            ></b-form-input>
            <b-form-input
                v-else-if="isType(['entityModalMultipleSelect','treeSelectMultiple'])"
                type="text"
                plaintext
                placeholder="请选择"
                @click="entityModalMultipleSelectClick($event,metadata)"
                v-model="myValue"
                class="form-control"
                @input="updateValue()"
                :disabled="metadata.disabled"
            ></b-form-input>
            <!-- 附件 -->
            <em-attachment
                v-else-if="isType(['emAttachment'])"
                :items="value"
                :metadata="metadata"
                :entity="entity"
                :isEditing="isEditing"
                :disabled="metadata.disabled"
            ></em-attachment>
            <b-form-select
                v-else-if="isType(['select', 'boolean', 'entitySelect','scheduledPeriodicUnit', 'dictEnumSelect'])"
                v-model="myValue"
                :options="options"
                @input="updateValue()"
                :disabled="metadata.disabled"
            ></b-form-select>
            <!--      下拉多选-->
            <div v-else-if="isType(['selectMultiple', 'entitySelectMultiple'])">
                <el-select v-model="myValue" multiple placeholder="请选择"
                           @input="updateValue()" class="w-100" :disabled="metadata.disabled">
                    <el-option
                        v-for="item in options"
                        :key="item.value"
                        :label="item.text"
                        :value="item.value">
                    </el-option>
                </el-select>
            </div>
            <!--        密码-->
            <b-form-input v-else-if="isType(['password'])" ref="dp" name="password" type="password" v-model="myValue"
                          @input="updateValue($event)" :disabled="metadata.disabled">
            </b-form-input>
            <!--        日期-->
            <b-form-input v-else-if="isType(['datepicker'])" ref="dp" name="date" type="date" v-model="myDate"
                          @input="dateUpdateValue($event)" :disabled="metadata.disabled">
            </b-form-input>
            <!--        日期时间-->
            <!--      <em-datetimepicker-->
            <!--          v-if="isType(['datetimepicker'])"-->
            <!--          ref="dtp"-->
            <!--          :datetime="myValue"-->
            <!--          @input="updateValue($event)"-->
            <!--          :disabled="metadata.disabled"-->
            <!--      ></em-datetimepicker>-->

            <el-date-picker v-else-if="isType(['datetimepicker'])" ref="dtp" v-model="myDateTime" type="datetime"
                            class="w-100" placeholder="选择日期时间"></el-date-picker>
            <b-form-textarea
                v-else-if="isType(['textarea'])"
                v-model="myValue"
                rows="1"
                max-rows="6"
                @input="updateValue($event)"
                :disabled="metadata.disabled"
            />
            <div v-else-if="isType(['input'])">
                <input type="text" v-model="myValue" class="form-control" @input="updateValue()"
                       :disabled="metadata.disabled"/>
            </div>
            <div v-else-if="isType(['inputNumber'])">
                <input type="number" v-model="myValue" class="form-control" @input="updateValue()"
                       :disabled="metadata.disabled"/>
            </div>
            <MmfQRCode
                v-else-if="isType(['inputQrcode'])"
                :text="myValue"
                @input="updateValue($event)"
                :disabled="metadata.disabled">
            </MmfQRCode>
            <Json v-else-if="isType(['json','json-params'])" v-model="myValue" enable-buttons @changed="updateValue"
                  :input-config="jsonInputConfig" :label-name="$t(metadata.label)"
                  class="json-style" :enable-param-config="isType(['json-params'])"></Json>
        </div>
        <div v-else-if="isType(['select', 'boolean','scheduledPeriodicUnit','entitySelect', 'dictEnumSelect'])">
            {{ getOption() }}
        </div>
        <div v-else>
            <em-attachment
                v-if="isType(['emAttachment'])"
                :items="value"
                :metadata="metadata"
                :entity="entity"
            ></em-attachment>
            <template v-else-if="isType(['textarea'])">
                <div data-toggle="tooltip" :title="formatValue">
                    {{ hideTextIfOverload(formatValue) }}
                </div>
            </template>
            <template v-else-if="isType(['json','json-params'])">
                <b-button variant="light" @click="$refs.jsonView.showModal()" v-if="formatValue">
                    {{ hideTextIfOverload(value) }}
                </b-button>
                <re-b-modal ref="jsonView" header="JSON查看">
                    <vue-json-pretty :data="formatValue" :deep="5"></vue-json-pretty>
                </re-b-modal>
            </template>
            <template v-else-if="(isType(['input']) || isType(['datepicker'])) && isLinkTo()">
                <b-link @click="linkTo($event)">
                    {{ formatValue }}
                </b-link>
                <bom-tree-modal v-if="isLinkTo('material_bom')"
                                ref="material_bom"
                                :material="formatValue"></bom-tree-modal>
            </template>
            <template v-else>{{ formatValue }}
                <span v-if="showDayLightTimeIcon">
                    <i class="fa fa-fw fa-lg fa-sun"></i>
                </span>
            </template>
        </div>
    </div>
</template>

<script>
import EmAttachment from "@/components/em/EmAttachment";
import MmfQRCode from "@/components/MmfQRCode";
import moment from "moment";
import {TIMEZONE} from "@/model/constants";
import ReBModal from "@/components/echarts-part/CalendarShift/cells/stuffs/ReBModal";
import Json from "@/views/report/jsonEdit/JsonEdit";
import VueJsonPretty from 'vue-json-pretty';
import 'vue-json-pretty/lib/styles.css';
import BomTreeModal from "@/components/bom/BomTreeModal.vue";

const typeMapping = {
    select: {},
    boolean: {
        options: [
            {value: true, text: "lbl.basic.yes"},
            {value: false, text: "lbl.basic.no"}
        ]
    },
    scheduledPeriodicUnit: {
        options: [
            {value: 1, text: "lbl.em.common.scheduledPeriodicUnit.day"},
            {value: 2, text: "lbl.em.common.scheduledPeriodicUnit.week"},
            {value: 3, text: "lbl.em.common.scheduledPeriodicUnit.month"},
            {value: 4, text: "lbl.em.common.scheduledPeriodicUnit.year"}
        ]
    },
    datepicker: {},
    datetimepicker: {},
    textarea: {},
    input: {},
    "input-number": {},
    MmfQRCode: {}
};

export default {
    name: "em-form-helper",
    components: {BomTreeModal, ReBModal, EmAttachment, MmfQRCode, Json, VueJsonPretty},
    props: {
        entity: {
            type: String,
            default: ""
        },
        metadata: Object,
        value: [String, Number, Boolean, Array, Object, Date, Function, Symbol],
        isEditing: {
            type: Boolean,
            default: false
        },
        selfRow: Object,
        formatCellValue: {
            type: Object,
            default: null
        },
    },
    data: function () {
        return {
            multiSelected: [],
            myValue:
                this.isType(["datetimepicker"]) && this.value === ""
                    ? null
                    : this.value,
            myDate: this.isType(["datepicker", "datetimepicker"]) && this.value && this.value.length >= 10
                ? this.value.slice(0, 10) : "",
            myDateTime: null,
            dictCode: null
        };
    },
    watch: {
        value: {
            handler() {
                this.myValue = this.isType(["datetimepicker"]) && this.value === ""
                    ? null
                    : this.value
                if (this.isType(["datetimepicker"])) {
                    this.myDateTime = this.myValue;
                }
                this.myDate = this.isType(["datepicker", "datetimepicker"]) && this.value && this.value.length >= 10
                    ? this.value.slice(0, 10) : "";
            },
            immediate: true
        },
        myDateTime() {
            if (this.isType(["datetimepicker"])) {
                console.log("datetime changed")
                this.myValue = moment(this.myDateTime).format(this.$t("em.datetime.format.viewMode"))
                if (this.myValue === 'Invalid date') {
                    this.myValue = ''
                }
                this.$emit("input", this.myValue);
            }
        }
    },
    computed: {
        customClass() {
            if (this.metadata && this.metadata.form && this.metadata.form.customClass) {
                return this.metadata.form.customClass(this.value)
            }
            return ""
        },
        options() {
            let optionsNotTranslated = null;
            let options = [];
            let form = this.metadata.form;
            let noEmptySelect = false;
            switch (form.type) {
                case form.type === "select" || form.type === "selectMultiple" ? form.type : -1:
                    if (form.options !== undefined) {
                        optionsNotTranslated = form.options;
                        if (!form.showLabelSelectOne) {
                            noEmptySelect = true;
                        }
                    }
                    break;
                case "boolean":
                    optionsNotTranslated = typeMapping["boolean"].options;
                    break;
                case "scheduledPeriodicUnit":
                    optionsNotTranslated = typeMapping["scheduledPeriodicUnit"].options;
                    break;
                case form.type === "entitySelect" || form.type === "entitySelectMultiple" ? form.type : -1:
                    if (!this.$store.state[form.entity]) {
                        console.error('EmFormHelper-options定义错误：', this.metadata)
                    } else if (this.$store.state[form.entity] && this.$store.state[form.entity].selectItems) {
                        if (this.$store.state[form.entity].selectItemsRefreshFlag) {
                            //
                        }
                        let opMap = this.$store.state[form.entity].selectItems;
                        options = opMap.get(this.metadata.key) || [];
                    }
                    if (!form.showLabelSelectOne) {
                        noEmptySelect = true;
                    }
                    break;
                case "dictEnumSelect":
                    if (this.$store.state.dictionaryEnumStore.reloadFlag) {
                        //reload
                    }
                    options = this.$store.getters["dictionaryEnumStore/getOptions"](form.entity);
                    break;
            }
            //把text转换为i18n的key
            if (optionsNotTranslated) {
                let $this = this;
                options = optionsNotTranslated.map(x => {
                    return {value: x.value, text: $this.$t(x.text)};
                });
            }
            if (!noEmptySelect) {
                let temp = [{value: "", text: this.$t("lbl.basic.select.one")}];
                options = temp.concat(options);
            }
            return options;
        },
        showDayLightTimeIcon() {
            if (this.metadata.form.type === "datetimepicker") {
                return (
                    moment(this.value).isDST() &&
                    this.$store.getters["userPreferences/getTimezone"] === TIMEZONE.DST
                );
            } else {
                return false;
            }
        },
        formatValue() {
            let tempValue = this.value;
            switch (this.metadata.form.type) {
                case "datetimepicker":
                    tempValue = this.value != null
                        ? moment(this.value).format(
                            // this.$store.getters["userPreferences/getDateTimeString"]
                            this.$t("em.datetime.format.viewMode")
                        )
                        : "";
                    break;
                case "datepicker":
                    tempValue = this.value != null
                        ? moment(this.value).format(this.$t("em.date.format.viewMode"))
                        : "";
                    break;
                case "year_month":
                    tempValue = this.value != null ? moment(this.value).format("YYYY-MM") : "";
                    break;
                case "hour_minute":
                    tempValue = this.value != null ? moment(this.value).format("HH:mm") : "";
                    break;
                case "json":
                case "json-params":
                    try {
                        tempValue = JSON.parse(this.value);
                    } catch (e) {
                        tempValue = this.value;
                    }
                    break;
            }
            let key = this.metadata.key;
            if (this.formatCellValue && this.formatCellValue[key]) {
                tempValue = this.formatCellValue[key](tempValue);
            }
            return tempValue;
        },
        jsonInputConfig() {
            if (this.isEditing && this.isType(['json', 'json-params'])) {
                let config = this.$store.getters["jsonInputConfigStore/getConfig"](this.entity, this.metadata.key);
                console.log('tried', config);
                if (config !== undefined && config != null) {
                    return config;
                }
            }
            return undefined;
        },
    },
    mounted() {
        let form = this.metadata.form;
        if (this.isEditing) {
            if (
                (form.type === "entitySelect" || form.type === "entitySelectMultiple") &&
                !form.hasOwnProperty("dependsOn")
            ) {
                //为select添加查询条件
                if (form.selectFilter) {
                    this.$store.commit(form.entity + "/setSelectFilter", form.selectFilter, {
                        root: true
                    });
                }
                this.$store.dispatch(form.entity + "/retrieveForSelect", {
                    key: this.metadata.key,
                    entity: form.entity
                }, {
                    root: true
                });
            } else if (form.type === "dictEnumSelect" && form.entity) {
                this.$store.dispatch('dictionaryEnumStore/queryDictionary', form.entity, {
                    root: true
                });
            }
        }
        this.$emit("bind", this.myValue);
    },
    methods: {
        isType(types) {
            return types.indexOf(this.metadata.form.type) >= 0;
        },
        getOption() {
            //把this.value强转为string
            let selectedOption = this.options.filter(x => (x.value + '') === (this.value + ''));
            if (selectedOption.length > 0) {
                return selectedOption[0].text;
            }
            return this.value;
        },
        updateValue(value = null) {
            let temp;
            if (value) {
                temp = value;
            } else {
                temp = this.myValue;
            }
            //json to string
            if (this.isType(["json"])) {
                temp = JSON.stringify(JSON.parse(temp));
            }
            this.$emit("input", temp);
            //todo 如果其他select依赖本select，则需要先更新该entity的selectItemsFilter，再刷新它的selectItems
            // this.$store.dispatch(this.metadata.form.entity + "/retrieveForSelect", {
            //     root: true
            // });
        },
        dateUpdateValue(value) {
            //有值就拼接0点0分
            if (value) {
                this.$emit("input", value + " 00:00:00")
            }
            //无值就直接emit “”
            else {
                this.$emit("input", "")
            }
        },
        entityModalSelectClick(ev, metadata) {
            this.$emit("selectModalEntity", metadata);
        },
        entityModalMultipleSelectClick(ev, metadata) {
            this.$emit("selectMultipleModalEntity", metadata);
        },
        datetimeStr2Date(datetimeStr) {
            let s = datetimeStr.replace(/-/g, "/");
            return new Date(s);
        },
        hideTextIfOverload(value) {
            let maxLength = 70;
            if (typeof value === 'string' && value.length > maxLength) {
                return value.substring(0, maxLength) + '...';
            }
            return value;
        },
        getViewedValue() {
            if (!this.isEditing) {
                return this.isType(['select', 'boolean', 'scheduledPeriodicUnit', 'entitySelect']) ? this.getOption() : this.formatValue;
            }
        },
        isLinkTo(linkType) {
            return linkType ? linkType === this.metadata.form.linkTo : this.metadata.form.linkTo;
        },
        linkTo(event) {
            if (this.isLinkTo('common_link')) {
                this.$emit('linkClick', event);
            } else if (this.isLinkTo('material_bom')) {
                let linkWith = this.getLinkWithObject();
                let parent = null;
                if (linkWith && linkWith['parentMaterial']) {
                    parent = linkWith.parentMaterial;
                }
                this.$refs.material_bom.showModal(parent);
            }
        },
        getLinkWithObject() {
            let linkWith = this.metadata.form.linkWith;
            if (linkWith && linkWith.length > 0) {
                let temp = {};
                for (let item of linkWith) {
                    temp[item.name] = this.selfRow[item.field];
                }
                return temp;
            }
            return null;
        },
    }
};
</script>

<style scoped>
.json-style {
    width: 100%;
    min-width: 200px;;
}

.json-style >>> .json-editor .CodeMirror {
    height: 100px;
}
</style>
